import { Constants } from "../../shared/constants/constants";
import { isDsV2 } from "./data-rev-helper";

export const isItemActivity = (itemType: number, pageType: number) => {
  if (!itemType || !pageType) return false;

  if (!isDsV2()) {
    return itemType === Constants.ACTIVITY_TYPES.OPERATIONAL_ACTIVITY;
  }

  const activitiesTypes = [Constants.ACTIVITY_TYPES.OPERATIONAL_ACTIVITY, Constants.ACTIVITY_TYPES.STRATEGIC_ACTIVITY];
  const activityType = activitiesTypes.find((e) => e === itemType);

  return activityType === pageType;
};

export const isItemProject = (itemType: number, pageType: number) => {
  if (!itemType || !pageType) return false;

  if (!isDsV2()) {
    return itemType === Constants.INITIATIVE_TYPES.REGULAR_TASK;
  }

  const projectsTypes = [Constants.INITIATIVE_TYPES.REGULAR_TASK, Constants.INITIATIVE_TYPES.STRATEGIC_PROJECT];
  const projectType = projectsTypes.find((e) => e === itemType);

  return projectType === pageType;
};

export const isItemObjective = (itemType: number, pageType: number) => {
  if (!itemType || !pageType) return false;

  const objectivesTypes = [
    Constants.OBJECTIVE_TYPE.ENABLER_OBJECTIVE,
    Constants.OBJECTIVE_TYPE.TRANSFORMATIONAL_OBJECTIVE,
    Constants.OBJECTIVE_TYPE.MAIN_OBJECTIVE,
    Constants.OBJECTIVE_TYPE.STRATEGIC_OBJECTIVE,
  ];

  if (!isDsV2()) {
    return objectivesTypes.some((e) => e === itemType);
  }

  const objectiveType = objectivesTypes.find((e) => e === itemType);

  return objectiveType === pageType;
};

export const isService = (itemType: number) => itemType === Constants.CONSTANT_SERVICE;
export const isObjective = (itemType: number) => itemType === Constants.CONSTANT_OBJECTIVETYPE;
export const isActivity = (itemType: number) => itemType === Constants.CONSTANT_ACTIVITYTYPE;
export const isStrategicActivity = (itemType: number) => itemType === Constants.ACTIVITY_TYPES.STRATEGIC_ACTIVITY;
export const isOperationalActivity = (itemType: number) => itemType === Constants.ACTIVITY_TYPES.OPERATIONAL_ACTIVITY;
export const isInitiative = (itemType: number) => itemType === Constants.CONSTANT_INITIATIVE;
export const isOpm = (kpiType: number) => kpiType === Constants.KPI_TYPE.OPM;
export const isMtkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.MTKPI;
export const isImkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.IMKPI;
export const isAikpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.AIKPI;
export const isMokpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.MOKPI;
export const isIptkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.IPTKPI;
export const isDkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.UAE;
export const isDtkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.DTKPI;
export const isNtkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.NTKPI;
export const isNkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.NKPI;
export const isEkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.EKPI;
export const isSkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.SKPI;
export const isSrvkpi = (kpiType: number) => kpiType === Constants.KPI_TYPE.SRVKPI;
export const isTpAggreementReadyToPublish = (objectType: number) =>
  objectType === Constants.CONSTANT_TP_AGREEMENT_READY_TO_PUBLISH;
